import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './AddSensor.css';
import AddSensorFilterForm from './components/AddSensorFilterForm';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
import { allUserSensorSelector } from '../../core/selectors/sensor.selector';
import _ from 'lodash';
import { sensorTypeOptions } from '../../constants/option.constant';
import modelEnum from '../../constants/model.enum';
import { convertLocalToUTC } from '../../constants/common.constant';

const AddSensorFilter = (props: any) => {

  const { sensor }: any = useSelector((state: IState) => { return state.sensor });
  const userType : any = useSelector((state: IState) => {return state.auth.userType});
  const allUsersData: any = useSelector(allUserSensorSelector);

  const dispatch = useDispatch();

  const initialFilter = {
    Building: "",
    Comments: "",
    CustomerId: "",
    Floor: "",
    ICCID: "",
    Location: "",
    Room: "",
    SendMail: false,
    User: "",
    UserId: -1,
    SensorType: 0,
  }

  useEffect(() => {
    if(userType === 'Administrator')
      dispatch(actions.getAllUser(1, 10000,true));
    else
      dispatch(actions.getAllUser(1, 10000,false));
    var value = JSON.parse(JSON.stringify(localStorage.getItem('SensonLocation.Filter')));
    if (value) {
      dispatch(actions.getSensorFilter(props.iccid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let val = {
    CurrentPage: 1,
    PageSize: 10,
    OrderBy: 'desc',
    SensorLocationParam: {
      ICCID: '',
      CustomerId: '',
      Building: '',
      Floor: '',
      Room: '',
      Location: '',

    }
  }

  const onSubmitForm = (values: any) => {
    let tempValues = {...values};
    values.UserId = values.UserId !== undefined ? +values.UserId : values.UserId;
    // let tempSensorType: number = parseInt(values.SensorType);
    // tempValues.SensorType = tempSensorType > -1 ? (tempSensorType === 0 ? modelEnum.IAQ.toLowerCase() : "other") : "";
    tempValues.SensorType = modelEnum.IAQ.toLowerCase(); //Fixed type for sensor IAQ
    tempValues.LatestPayloadStartDateTime = tempValues.LatestPayloadStartDateTime || null;
    tempValues.LatestPayloadEndDateTime = tempValues.LatestPayloadEndDateTime || null;
    val.CurrentPage = 1;
    val.PageSize = props.pager.pageLimit;
    val.SensorLocationParam = values;
      if( !(_.isEqual(tempValues, initialFilter)))
      {
        if(tempValues.SensorType === modelEnum.IAQ.toLowerCase()){
          dispatch(actions.getAllSensorFromIAQAervice({...val, SensorLocationParam: 
            {...tempValues, LatestPayloadStartDateTime: convertLocalToUTC(tempValues.LatestPayloadStartDateTime),
                  LatestPayloadEndDateTime: convertLocalToUTC(tempValues.LatestPayloadEndDateTime)
                }}));
        }
        else
          dispatch(actions.getAllSensor({...val, SensorLocationParam: {...tempValues}}));
        localStorage.setItem('SensonLocation.Filter', JSON.stringify(val.SensorLocationParam));
        props.setHasFilterFun(val.SensorLocationParam)
      }
      props.modalClosed();
  }

  const onModalClosed = () => {
    dispatch(actions.resetAddSensorState())
    dispatch(actions.resetGetSensorByIdState())
    dispatch(reset('AddSensorFilterForm'));
    props.modalClosed();
  }

  const onClearFilter = () => {
    val.CurrentPage = props.pageInfo.currentPage;
    val.PageSize = props.pager.pageLimit;
    localStorage.removeItem('SensonLocation.Filter');
    dispatch(actions.getAllSensor(val));
    dispatch(actions.resetAddSensorState())
    dispatch(actions.resetGetSensorByIdState())
    dispatch(reset('AddSensorFilterForm'));
    props.setHasFilterFun("")
    props.modalClosed();
  }

  return (
    <React.Fragment>
      <AddSensorFilterForm
        id={props.id}
        isDelete={props.isDelete}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        onClearFilter={onClearFilter}
        getSensorLoading={sensor.loading}
        userList={allUsersData}
        sensorTypeList={sensorTypeOptions}
      />
    </React.Fragment>
  );
};

export default AddSensorFilter;
